var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"pt-4 pb-4",attrs:{"cols":"12","sm":"12","md":"8","lg":"9"}},[(!_vm.networkingHasAccess)?[_c('NetworkingNoAccessWidget')]:_vm._e(),(_vm.networkingHasAccess)?_c('b-row',[(_vm.networkingChatAgreement)?_c('NetworkingChat'):_vm._e(),_c('NetworkingConsent')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }